import React from 'react';
import UploadComponent from './UploadComponent';

export function Upload({ getFolders, createFolder, users, handleUpload, setFolderUid, multiple, size, fileTypes, getFilesFromFileSystem, permissions, folderUid, assets, setAssets, displayType, onDisplayTypeChange }: any) {
	return (
		<UploadComponent
			getFolders={getFolders}
			createFolder={createFolder}
			users={users}
			handleUpload={handleUpload}
			folderUid={folderUid}
			setFolderUid={setFolderUid}
			permissions={permissions}
			multiple={multiple}
			size={size}
			fileTypes={fileTypes}
			getFilesFromFileSystem={getFilesFromFileSystem}
			displayType={displayType}
			onDisplayTypeChange={onDisplayTypeChange}
			assets={assets}
			setAssets={setAssets}
		/>
	)
}
